// extracted by mini-css-extract-plugin
module.exports = {"ArticleRichText":"ArticleRichText_ArticleRichText__DD0Cc"};